/* eslint-disable react/no-array-index-key */
import React, { useMemo, useState } from 'react';

import { IDeliveryNote } from 'commons/types';

import { DNPrintTemplateComponent } from './DNPrintTemplate.component';

const DNPrintTemplate: React.FC = () => {
  document.body.className = 'print-template';
  const [dnPageBreak, setDnPageBreak] = useState<React.JSX.Element[]>([]);

  const data: IDeliveryNote | null = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('delivery-note') || 'null');
    } catch (err) {
      // In case stored data is invalid JSON, fall back to null
      return null;
    }
  }, []);
  if (!data) return null;

  const setDnPageBreakFromPageNumber = (pageNumber: number) => {
    // set dn page break
    const pageBreak: React.JSX.Element[] = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < pageNumber - 1; i++) {
      pageBreak.push(<div style={{ pageBreakAfter: 'always' }} />);
    }
    setDnPageBreak(pageBreak);
  };

  return (
    <>
      <DNPrintTemplateComponent
        data={data}
        copyNumber={0}
        setDnPageBreakFromPageNumber={setDnPageBreakFromPageNumber}
      />
      {dnPageBreak}
      <DNPrintTemplateComponent data={data} copyNumber={1} />
    </>
  );
};

export default DNPrintTemplate;
